import { render } from "./NewContactList.vue?vue&type=template&id=e4a20198"
import script from "./NewContactList.vue?vue&type=script&lang=js"
export * from "./NewContactList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__